import { Link } from "react-router-dom";
import { siteContent } from "../../content/siteContent";
import { ForYou } from "./ForYou";
import { trackCtaClick } from "../../lib/analytics";

export function Hero() {
  const { hero } = siteContent;

  return (
    <section className="home-hero" aria-labelledby="home-hero-title">
      <div className="home-shell home-hero__grid">
        <div className="home-hero__copy">
          <p className="home-eyebrow home-hero__eyebrow">{hero.eyebrow}</p>
          <h1 id="home-hero-title" className="home-hero__title">
            {hero.titleLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h1>
          <div className="home-hero__intro">
            <p>{hero.text}</p>
            <div className="home-hero__actions">
              <Link
                className="home-button home-button--hero"
                to={hero.primaryCta.href}
                reloadDocument
                onClick={() => trackCtaClick("hero")}
              >
                {hero.primaryCta.label}
                <span aria-hidden="true">↗</span>
              </Link>
              <a className="home-text-link" href={hero.secondaryCta.href} onClick={() => trackCtaClick("hero_method")}>
                {hero.secondaryCta.label}
                <span aria-hidden="true">↓</span>
              </a>
            </div>
            <p className="home-hero__cta-note">{hero.ctaNote}</p>
          </div>
        </div>

        <ForYou />
      </div>
    </section>
  );
}
